/* ============================================================================
   BeanBurds — icon label flash (D-toolbar, 29 Jul)

   Every consolidated toolbar control carries data-bbc-iclabel. Tapping one
   flashes that name, so an unfamiliar glyph is never a guess (Salem, 29 Jul:
   "when people tap on it the name can appear shortly to show them what it
   exactly is if there were not able to tell by the icon"). Desktop also gets
   the plain title tooltip straight off the markup.

   Reuses the EXISTING #bbc-toast node and .toast styles that bb-coffee.js and
   bb-collection-v5.js already create — same id, same class — so there is only
   ever one toast element on the page and no second component ships for this.

   NO requestAnimationFrame. The other two files use rAF to commit the
   pre-transition state, which is correct in a normal tab but never fires in a
   throttled or unfocused one — leaving the toast stuck at opacity 0. That is
   also why it could not be verified from an automated browser on 29 Jul.
   Reading offsetWidth forces the same style flush synchronously, so the
   transition always runs and the behaviour is testable anywhere.
   ============================================================================ */
(function () {
  'use strict';
  if (window.__bbIcLabels) return; window.__bbIcLabels = true;

  var timer;
  function flash(msg) {
    if (!msg) return;
    var host = document.getElementById('bbc-app') || document.querySelector('.bbc-root') || document.body;
    var t = document.getElementById('bbc-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'bbc-toast';
      t.className = 'toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      host.appendChild(t);
    }
    t.classList.remove('show');
    t.textContent = msg;
    void t.offsetWidth; /* commit the hidden state before transitioning in */
    t.classList.add('show');
    clearTimeout(timer);
    timer = setTimeout(function () { t.classList.remove('show'); }, 1500);
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-bbc-iclabel]');
    if (!el) return;
    flash(el.getAttribute('data-bbc-iclabel'));
  });

  window.__bbFlashLabel = flash;
})();
